import { useEffect, useState } from "react";
import { getPage } from "../api/storefront";

export function pageBlocks(page) {
  return Array.isArray(page?.content) && page.content.length ? page.content : null;
}

export function useManagedPageContent(slug) {
  const [page, setPage] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoaded(false);
    getPage(slug)
      .then((data) => { if (!cancelled) setPage(data); })
      .catch(() => { if (!cancelled) setPage(null); })
      .finally(() => { if (!cancelled) setLoaded(true); });
    return () => { cancelled = true; };
  }, [slug]);

  return { page, blocks: pageBlocks(page), loaded };
}
